import React, { useEffect, useState } from "react";
import { Card, CardBody, CardHeader, Table } from "reactstrap";
import Skeleton from "react-loading-skeleton";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useLoader } from "../../_helper/LoaderContext";
import { usePharmacy } from "../../_helper/PharmacyProvider";
import { getNearToExpireStocks } from "../PharmacyManageStocks/ManageStocksService";

const fetchNearlyExpired = () =>
	new Promise((resolve) => {
		setTimeout(() => {
			resolve([
				{ name: "Paracetamol", batch: "B123", expiry: "2025-09-20" },
				{ name: "Ibuprofen", batch: "B456", expiry: "2025-09-25" },
				{ name: "Ibuprofen", batch: "B456", expiry: "2025-09-25" },
				{ name: "Ibuprofen", batch: "B456", expiry: "2025-09-25" },
				{ name: "Ibuprofen", batch: "B456", expiry: "2025-09-25" },
				{ name: "Ibuprofen", batch: "B456", expiry: "2025-09-25" },
				{ name: "Ibuprofen", batch: "B456", expiry: "2025-09-25" },
				{ name: "Ibuprofen", batch: "B456", expiry: "2025-09-25" },
				{ name: "Ibuprofen", batch: "B456", expiry: "2025-09-25" },
				{ name: "Ibuprofen", batch: "B456", expiry: "2025-09-25" },
			]);
		}, 1000);
	});

const NearlyExpiredProducts = () => {
	const { t } = useTranslation();
	const [data, setData] = useState([]);
	const [page, setPage] = useState(1);
	const [size, setSize] = useState(10);
	const { loading, setLoading } = useLoader();
	const { pharmacyPOS } = usePharmacy();
	const [skeletonLoading, setSkeletonLoading] = useState(false);
	const history = useNavigate();

	useEffect(() => {
		getStocks();
		// fetchNearlyExpired().then((res) => {
		// 	setData(res);
		// 	setLoading(false);
		// });
	}, []);

	const getStocks = async () => {
		const body = {
			clinicId: pharmacyPOS?.hospital_id,
			page: page,
			limit: size,
			search: ''
		};
		try {
			setLoading(true);
			setSkeletonLoading(true);
			const response = await getNearToExpireStocks(body);
			if (response.data.success) {
				setData(response.data.data.stocks || []);
			} else {
				setData([]);
			}
			// const totalCount = response.data.data.total || 0;
			// setTotalItems(Math.ceil(totalCount / size));
		} catch (error) {
			console.error("Error fetching sales history:", error);
		} finally {
			setLoading(false);
			setSkeletonLoading(false);
		}
	};

	const formatDate = (dateString) => {
		if (!dateString) return "N/A";
		const date = new Date(dateString);
		const day = date.getDate().toString().padStart(2, '0');
		const month = date.toLocaleString(undefined, { month: 'short' });
		const year = date.getFullYear();
		return `${day} ${month} ${year}`; // Example: May 07, 2025
	};

	const gotoList = () => {
		history(`${process.env.PUBLIC_URL}/near-expire-stock`);
	}

	return (
		<Card className="h-100">
			{/* <CardHeader>
				{t("Top 10 Nearly Expired Products")}
			</CardHeader> */}
			<CardHeader className="d-flex justify-content-between align-items-center">
				<h6 className="mb-0">{t("Items Expiring Soon")}</h6>
				<button
					type="button"
					onClick={gotoList}
					className="btn btn-link p-0 text-primary small text-underline"
					style={{ textDecoration: "none" }}
				>
					{t("View All")}
				</button>
			</CardHeader>
			<CardBody>
				{loading ? (
					<Skeleton count={5} height={30} />
				) : data.length === 0 ? (
					<p className="text-center text-muted">{t("No nearly expired products found")}</p>
				) : (
					<div className="tw-h-[250px]" style={{ overflow: 'auto' }}>
						<Table size="sm" striped bordered responsive>
							<thead>
								<tr>
									<th>{t("Product Name")}</th>
									{/* <th>{t("Salt name")}</th> */}
									<th style={{ whiteSpace: "nowrap" }}>{t("Expiry Date")}</th>
								</tr>
							</thead>
							<tbody>
								{data.map((item, idx) => (
									<tr key={idx}>
										{/* <td>{item.name}</td> */}
										<td>
											<span
												className="d-inline-block text-truncate"
												style={{ maxWidth: "100%", whiteSpace: "nowrap" }}
												title={item.brandName}
											>
												{item.brandName}
											</span>
										</td>
										<td>{formatDate(item.stockData[0].expiryDate)}</td>
										{/* <td style={{ whiteSpace: "nowrap" }}>{formatDate(item.expiry)}</td> */}
									</tr>
								))}
							</tbody>
						</Table>
					</div>
				)}
			</CardBody>
		</Card>
	);
};

export default NearlyExpiredProducts;
